/**
 * 路由拦截
 * @param to
 * @param from
 * @param next
 * Created by ls on 2018/4/20.
 */
import Cookies from 'js-cookie';
import i18n from '@/i18n/i18n';

const beforeEach = (to, from, next) => {
    let routeArr = to.path.split('/');
    if (routeArr[1] === 'en') {
        // 分享链接时，根据语言标识切换语言
        // document.getElementById('app').className = 'lang_en';
        Cookies.set('HY_LANGUAGE', 'en');
        i18n.locale = 'en';
    } else {
        // document.getElementById('app').className = 'lang_zhCN';
        // console.log('&&&&&&&&&&&&&&&&&&&&&&&&&', document.getElementById('app'))
        Cookies.set('HY_LANGUAGE', 'zhCN');
        i18n.locale = 'zhCN';
    }
  next()
};
export default beforeEach;



// WEBPACK FOOTER //
// ./src/router/beforeEach.js